import React from 'react';
import { Link , useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  // Link,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import LoginService from 'src/services/sigin-signup/login.service';
import LocalStorageService from 'src/services/storage/local-storage.service';
import { Alert } from 'src/components/toaster/alert.component';
import { alertService } from 'src/components/toaster/alert.service';
import TermsAndConditions from '../shared/components/alert/TermsAndConditions';
import { withRouter } from 'react-router-dom';
import { history } from 'src/utils/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));
const loginService = new LoginService();
const localStorageService = LocalStorageService.getService();
const RegisterView = () => {
  if(localStorage.token){
    history.push('/app/dashboard');
  }
  const [registerState, setRegisterState] = React.useState({
    email: '',
    userName: '',
    password: '',
    policy: false
  })
  const [alertState, setAlertState] = React.useState({
    open: false,
    severity: 'success',
    displayMessage: 'Hello World'
  });

  
  const handleOnAgree = (isAgreed) => {
    setRegisterState({
      email: registerState.email,
      userName: registerState.userName,
      password: registerState.password,
      policy: isAgreed
    });
  }

  const handleUpdate = (registerState) => {
    setRegisterState(registerState);
  }
  const handlePolicyUpdate = (registerState) => {
    setRegisterState({
      email: registerState.email,
      userName: registerState.userName,
      password: registerState.password,
      policy: !registerState.policy
    });
  }
  const classes = useStyles();
 // const navigate = useNavigate();
  const autoClose= true;
  const keepAfterRouteChange= true
  
  return (
    <React.Fragment>
    <Alert id="left-alert" />
    <Page
      className={classes.root}
      title="Register"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={registerState}
            enableReinitialize={true}
            validationSchema={
              Yup.object().shape({
                email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
                userName: Yup.string().max(255).required('Name is required'),
                password: Yup.string().max(255).required('password is required'),
                policy: Yup.boolean().oneOf([true], 'Please accept to our T&C')
              })
            }
            onSubmit={(values) => {
              loginService.userSignup(values).then((res) => {
                if (res) {
                  alertService.success(
                    res.message ?? "User has been registered successfully."
                  )
                //   localStorageService.setToken(res);
                //   localStorage.setItem('user', res.userName);
                //   setAlertState({
                //     open: true,
                //     severity: 'success',
                //     displayMessage: 'User has been registered successfully.'
                //   })
                //  history.push('/app/dashboard/true');
                }
              }).error((err) => {
                console.log(':: err', err);
              });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={2}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                  >
                    Create new account
                  </Typography>
                  <Typography
                  align="right"
                    gutterBottom
                    variant="body2"
                  >
                    (Use your email to create new account)
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.userName && errors.userName)}
                  fullWidth
                  helperText={touched.userName && errors.userName}
                  label="Name"
                  margin="normal"
                  name="userName"
                  onBlur={()=>handleUpdate(values)}
                  onChange={handleChange}
                  value={values.userName}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email Address"
                  margin="normal"
                  name="email"
                  onBlur={()=>handleUpdate(values)}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={()=>handleUpdate(values)}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box 
                  alignItems="center"
                  display="flex"
                  ml={-1}
                >
                  <Checkbox
                    checked={values.policy}
                    name="policy"
                    onChange={()=>handlePolicyUpdate(values)}
                  />
                  <Typography
                    variant="body1"
                  >
                    I have read the
                    {' '}
                    <TermsAndConditions onAgree={handleOnAgree} />
                  </Typography>
                </Box>
                {Boolean(touched.policy && errors.policy) && (
                  <FormHelperText error>
                    {errors.policy}
                  </FormHelperText>
                )}
                
                <Box my={2}>
                  <Button
                    color="primary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Sign up now
                  </Button>
                </Box>
                <Typography
                  align="right"
                  variant="body1"
                >
                  Have an account?
                  {' '}
                  <Link
                    to="/auth/login"
                    variant="h6"
                  >
                    Sign in
                  </Link>
                </Typography>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
    </React.Fragment>
  );
};

export default withRouter(RegisterView);
